import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Phone, MessageSquare, Bot } from "lucide-react";
import { PHONE, TEL, SMS } from "@/lib/config";
import { PrimaryBtn, OutlineBtn, FinancingNote } from "@/components/site/shared";
import { openGhost } from "@/components/site/GhostAI";

export default function QuoteConfirmation() {
  const [params] = useSearchParams();
  const id = params.get("id");
  return (
    <section className="section-pad">
      <div className="max-w-2xl mx-auto px-4 text-center" data-testid="quote-confirmation">
        <div className="h-20 w-20 rounded-full bg-green-100 flex items-center justify-center mx-auto">
          <CheckCircle2 className="w-11 h-11 text-green-600" />
        </div>
        <h1 className="font-head font-extrabold uppercase text-3xl sm:text-4xl text-[var(--navy)] tracking-tight mt-6">Request Received!</h1>
        <p className="text-[var(--text-muted)] mt-3">Thank you for contacting Veterans Power Wash & Cleaning Services. A team member will review your request and follow up.</p>
        {id && <p className="mt-4 inline-block bg-[var(--surface)] px-4 py-2 rounded-full text-sm font-semibold text-[var(--navy)]" data-testid="confirmation-lead-id">Reference: {id}</p>}

        <div className="flex flex-wrap justify-center gap-3 mt-8">
          <a href={TEL} className="btn-lift bg-[var(--red)] text-white font-semibold px-6 py-3 rounded-full flex items-center gap-2"><Phone className="w-4 h-4" /> Call {PHONE}</a>
          <OutlineBtn href={SMS}><MessageSquare className="w-4 h-4 text-[var(--action)]" /> Text Us</OutlineBtn>
          <OutlineBtn onClick={openGhost}><Bot className="w-4 h-4" /> Ask Ghost AI</OutlineBtn>
        </div>

        <div className="mt-8 text-left"><FinancingNote /></div>
        <div className="mt-8"><Link to="/" className="text-[var(--action)] font-semibold hover:underline">← Back to Home</Link></div>
      </div>
    </section>
  );
}
